import { render } from "./OrderProfitBreakdown.vue?vue&type=template&id=e953816c&scoped=true"
import script from "./OrderProfitBreakdown.vue?vue&type=script&lang=js"
export * from "./OrderProfitBreakdown.vue?vue&type=script&lang=js"

import "./OrderProfitBreakdown.vue?vue&type=style&index=0&id=e953816c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e953816c"]])

export default __exports__